import React, { useEffect, useState } from "react"
import Layout from "../components/layout"
import { SSR_BASE_URL } from "../helpers/constants"
import styled from "styled-components"

const WishlistProductFrame = styled.iframe`
  overflow: scroll;
  overflow-x: hidden;
  border: none;
  -ms-overflow-style: none;
  scrollbar-width: none;
  width: 100%;
  height: 100vh;
  & ::-webkit-scrollbar {
    display: none;
  }
`

const WishlistProductDetailBox = styled.div`
  display: flex;
  width: 100%;
  padding: 0;
  @media (min-width: 768px) {
    padding: 2.4rem 0;
  }
`

const WishlistProduct = props => {
  let { wishlistid, id } = props
  const [wishlistIdState, setWishlistIdState] = useState("")
  const [skuId, setSkuId] = useState("")
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    if (id) {
      setSkuId(id)
    }
    if (wishlistid) {
      setWishlistIdState(wishlistid)
    }
  })

  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <Layout {...props} minHeight="10rem" showFooterInMobile={false}>
      {mounted && (
        <WishlistProductDetailBox>
          {skuId && (
            <WishlistProductFrame
              src={`${SSR_BASE_URL}/wishlist/${wishlistIdState}/product/${skuId}`}
            />
          )}
        </WishlistProductDetailBox>
      )}
    </Layout>
  )
}

export default WishlistProduct
